import { render, staticRenderFns } from "./DashboardCarpark.vue?vue&type=template&id=644034a5&scoped=true"
import script from "./DashboardCarpark.vue?vue&type=script&lang=js"
export * from "./DashboardCarpark.vue?vue&type=script&lang=js"
import style0 from "./DashboardCarpark.vue?vue&type=style&index=0&id=644034a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644034a5",
  null
  
)

export default component.exports